import styled from '@emotion/styled'
import type { FC } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EmailCaptureForm from '@segment/templates/Forms/EmailCaptureForm'

import { disclaimer } from './disclaimer'

const copyText = {
  title: `Stay in the know`,
  line1: `Want to be the first to know about Segment events?`,
  line2: `Submit your email below, and we'll add you to our invite list.`,
}

const emailCaptureOverrides = {
  buttonText: `Keep me updated`,
  buttonUrl: `#past-webinars`,
  successButtonText: `See Past Webinars`,
  successMessageHeading: `You're on the list!`,
  successMessageDescription: `You are now registered for Segment event updates. Keep an eye on your inbox, we'll see you soon.`,
}

const StayInTheKnow: FC = () => {
  return (
    <StyledSectionBase variant="centered">
      <CopyTextBase>
        <Section.Copy>
          <CopyText.Heading tag="h2">{copyText.title}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copyText.line1}
            <br /> {copyText.line2}
          </CopyText.Description>
        </Section.Copy>
      </CopyTextBase>
      <StyledSectionContents>
        <EmailCaptureForm
          buttonText={emailCaptureOverrides.buttonText}
          successButtonText={emailCaptureOverrides.successButtonText}
          successMessageHeading={emailCaptureOverrides.successMessageHeading}
          successMessageDescription={emailCaptureOverrides.successMessageDescription}
          buttonUrl={emailCaptureOverrides.buttonUrl}
          customFormIdentifier="cs-events-email"
          customTrackingType="cs-events-email"
          customDisclaimer={disclaimer}
        />
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 32px;
  }
`

const StyledSectionContents = styled(Section.Contents)`
  max-width: 417px;
`

export default StayInTheKnow
